/**
 * Log an error if running locally.
 */
export function logError(message: any): void {
    if (process.env.NODE_ENV === "development") {
        console.error(message);
    }
}
